import { useParams } from "react-router-dom"
import { useCancelOrderMutation, useGetOrderQuery, usePayOrderMutation } from "../../features/CallApi"
import { Button, ButtonGroup, Card, CardBody, CardHeader, Container } from "reactstrap"
import { OrderStatus } from "./OrderStatus"
import { TypeOfPay } from "./OrderTypeOfPay"
import { useEffect, useRef } from "react"
import LoadScreen from "../UI/LoadScreen"
import { useForm } from "react-hook-form"
import { useState } from "react"
import useToken from "../useToken"
import { format } from "date-fns"
import { Col, FloatingLabel, Form, InputGroup, Row } from "react-bootstrap"
import { XCircle } from "react-bootstrap-icons"


export const OrderDetails = () => {
    const { id } = useParams()
    const { data, refetch, isLoading } = useGetOrderQuery(id)
    const [payOrder, { isLoading: isPaying }] = usePayOrderMutation()
    const [cancelOrder, { isLoading: isCanceling }] = useCancelOrderMutation()
    const { register, handleSubmit, formState: { errors }, setValue } = useForm()
    const [summ, setSumm] = useState(0)
    const { token } = useToken();
    const [downloadingAgreement, setDownloadingAgreement] = useState();
    const [orderChanging, setOrderChanging] = useState()
    const [selPayType, setSelPayType] = useState("")
    const [selSumm, setSelSumm] = useState()
    const [paymentsType, setPaymentsType] = useState([])
    const [pushing, setPushing] = useState()
    const [summPayments, setSummPayments] = useState(0)

    useEffect(() => {
        if (data?.items) {
            const sum = data.items.reduce((summa, item) => {
                return summa + (parseFloat(item.price) * item.quantity);
            }, 0);
            setSumm(sum)
        }
    }, [data])

    useEffect(() => {
        setOrderChanging(isPaying)
    }, [isPaying])
    useEffect(() => {
        setOrderChanging(isCanceling)
    }, [isCanceling])

    // useEffect(() => { console.log(summPayments) }, [summPayments])

    useEffect(() => {
        setValue("typeOfPay", data?.typeOfPay ? data.typeOfPay : null)
        if (data && data.paymentsData !== null) {
            const paymentsData = JSON.parse(data.paymentsType)
            setPaymentsType(paymentsData)
            setSummPayments(0)
        }
    }, [data])

    const addPaymentsType = (data) => {
        setPushing(true)

        console.log(data.sum)

        if (data.sum > summ) {
            setPushing(false)
            return window.alert("Введенная сумма оплаты привышает сумму заказа")
        }
        if (data.sum + summPayments > summ) {
            setPushing(false)
            return window.alert("Сумма типов оплаты привышает сумму заказа")
        }

        if (paymentsType) {
            const item = paymentsType.find(paymentsType => paymentsType.type == data.type)
            if (item) {
                const newSumm = Number(data.sum) + Number(item.sum)
                console.log(newSumm)
                const indexItem = paymentsType.indexOf(item)
                paymentsType[indexItem].sum = newSumm
            } else {
                paymentsType.push(data)
            }
        }
        else {
            setPaymentsType([data])
        }
        if (paymentsType) {
            const sum = paymentsType.reduce((summa, paymentType) => {
                return summa + (parseFloat(paymentType.sum));
            }, 0);
            setSummPayments(sum)
        }
        setSelPayType("")
        setSelSumm(null)
        setPushing(false)
    }
    const exactAmount = (data) => {
        setPushing(true)
        setPaymentsType([data])
        setSelPayType("")
        setSelSumm(null)
        setSummPayments(data.sum)
        console.log(paymentsType)
        setTimeout(() => {
            setPushing(false)
        }, 500)

    }

    const deletePaymentsType = (type) => {
        setPushing(true)
        const item = paymentsType.find(paymentsType => paymentsType.type == type)
        const indexItem = paymentsType.indexOf(item)
        paymentsType.splice(indexItem, 1)
        if (paymentsType) {
            const sum = paymentsType.reduce((summa, paymentType) => {
                return summa + (parseFloat(paymentType.sum));
            }, 0);
            setSummPayments(sum)
        }
        setTimeout(() => {
            setPushing(false)
        }, 500);
    }

    const pay = async (data) => {
        if (summPayments === summ) {
            data.paymentsTypeData = JSON.stringify(paymentsType)
            try {
                console.log(data)
                if ((data.elctReceipt === null || data.elctReceipt === undefined)) {
                    console.log("false")
                    data.elctReceipt = false
                }
                await payOrder(data).unwrap()
                refetch()
            }
            catch (error) {
                alert("Ошибка закрытия заказа, повторте оплату")
                console.error(error)
            }
        }
        else {
            return window.alert("Сумма не достаточно для оплаты")
        }


    }
    const cancel = async () => {
        try {
            await cancelOrder(id).unwrap()
            refetch()
        }
        catch (error) {
            alert("Ошибка отмены заказа")
            console.error(error)
        }

    }
    const agreement = async () => {
        setDownloadingAgreement(true)
        fetch(`/api/orders/agreement/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(res => res.blob())
            .then(blob => {
                var file = window.URL.createObjectURL(blob);
                window.open(file, "_blank");
                setDownloadingAgreement(false)
            }).catch((errors) => {
                console.log(errors)
                setDownloadingAgreement(false)
            })
    }

    return (
        <Container>
            {!isLoading ?
                <Card>
                    <CardHeader>
                        <h2>Заказ №{data.id}</h2>
                        <div className="d-flex">
                            <div className="me-1">Покупатель:</div>
                            <div style={{ fontWeight: "600" }}>{data.client.lastName} {data.client.firstName} {data.client.patronymic}</div>
                        </div>
                        <div className="d-flex">
                            <div className="me-1">Статус:</div>
                            <div><OrderStatus status={data.status} /></div>
                        </div>
                        <div className="d-flex">
                            <div className="me-1">Кассир:</div>
                            <div style={{ fontWeight: "600" }}>{data.user.lastName} {data.user.firstName}</div>
                        </div>
                        <div className="d-flex">
                            <div className="me-1">Сумма заказа:</div>
                            <div style={{ fontWeight: "600" }}>{summ} руб.</div>
                        </div>
                        <div className="d-flex">
                            <div className="me-1">Дата заказ:</div>
                            <div style={{ fontWeight: "600" }}>{format(new Date(data.orderDate), "dd.MM.yyyy HH:mm:ss")}</div>
                        </div>

                        <ButtonGroup>
                            <Button className="mt-3" onClick={() => agreement()} color="info" size="sm">
                                {downloadingAgreement ?
                                    <div className="text-center">
                                        <div className="spinner-border spinner-border-sm me-3 ms-3 mt-1 text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div> :
                                    <span className="text-light">Договор</span>}
                            </Button>
                            {data.receiptUrl ?
                                <Button className="mt-3" size="sm" color="success" onClick={() => { window.open(data.receiptUrl, "_blank", "noreferrer") }}>Электронный чек</Button> : <></>
                            }
                        </ButtonGroup>
                        {!orderChanging ? <div>
                            {data.status != 0 ?
                                <div className="d-flex">
                                    <div className="me-1">
                                        Тип оплаты:
                                        {paymentsType &&
                                            <>
                                                {
                                                    paymentsType.map(item =>
                                                        <div key={item.type} >
                                                            <h5 style={{ fontWeight: 600 }}>
                                                                {item.type === "card" && "Банковской картой"}
                                                                {item.type === "cash" && "Наличными"}: {item.sum} руб.
                                                            </h5>
                                                        </div>
                                                    )}
                                            </>
                                        }
                                        {/* <div>
                                            <h5>Итог:  {summPayments}</h5>
                                        </div> */}
                                    </div>
                                    {data.typeOfPay !== null &&
                                        <div>
                                            <TypeOfPay typeOfPay={data.typeOfPay} />

                                        </div>
                                    }
                                </div> :
                                <form onSubmit={handleSubmit(pay)}>

                                    <div className="mt-3">
                                        <Row>
                                            <Col lg={'4'}>

                                                <input value={id} hidden {...register("id")} />
                                                <InputGroup>
                                                    <FloatingLabel
                                                        controlId="floatingSelectGrid"
                                                        label="Тип оплаты"
                                                    >
                                                        <Form.Select onClick={(e) => { setSelPayType(e.currentTarget.value) }} defaultValue={selPayType} aria-label="Тип оплаты">
                                                            <option hidden disabled value="">-- Выберите тип оплаты --</option>
                                                            <option value="card">Банковской картой</option>
                                                            <option value="cash">Наличными</option>
                                                        </Form.Select>
                                                    </FloatingLabel>
                                                </InputGroup>
                                                {selPayType && <>
                                                    <InputGroup className="mt-3">
                                                        {/* <FloatingLabel controlId="floatingInputGrid" label="Сумма"> */}
                                                        <Form.Control type="number" onBlur={(e) => { setSelSumm(e.currentTarget.value) }} placeholder="Сумма" />
                                                        {/* </FloatingLabel> */}
                                                        <Button color="success" onClick={() => { addPaymentsType({ type: selPayType, sum: Number(selSumm) }) }}>Добавить</Button>
                                                    </InputGroup>
                                                    <Button onClick={() => { exactAmount({ type: selPayType, sum: Number(summ) }) }} className="mt-3 w-100" color="primary">
                                                        Точная сумма
                                                    </Button>
                                                    <div>
                                                        {errors.typeOfPay && <span className='text-danger'>{errors.typeOfPay?.message}</span>}
                                                    </div>
                                                </>}
                                                {data.client.email &&
                                                    <div className="form-check form-switch mt-3">
                                                        <label className="form-check-label">Отправить электронный чек</label>
                                                        <input type="checkbox" className="form-check-input" {...register("elctReceipt", {})} />
                                                    </div>
                                                }

                                            </Col>
                                            <Col>
                                                {!pushing ?
                                                    <>
                                                        {paymentsType &&
                                                            <>
                                                                {paymentsType.length > 0 &&
                                                                    <>
                                                                        <h6>Типы оплат:</h6>
                                                                        {paymentsType.map(payment =>
                                                                            <Row key={payment.type} className="border-bottom">
                                                                                <Col xs={5}>
                                                                                    <div>
                                                                                        <h5>
                                                                                            {payment.type === "card" && "Банковской картой"}
                                                                                            {payment.type === "cash" && "Наличными"}
                                                                                        </h5>
                                                                                    </div>
                                                                                    <div>
                                                                                        <h4>{payment.sum} руб.</h4>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col>
                                                                                    <Button color="danger" onClick={() => { deletePaymentsType(payment.type) }}><XCircle /></Button>
                                                                                </Col>
                                                                            </Row>
                                                                        )}
                                                                        <h5 className="mt-1">Сумма: {summPayments} руб. {summ - summPayments !== 0 && `(к доплате: ${summ - summPayments} руб.)`} </h5>
                                                                    </>
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        <LoadScreen height="10" />
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                    <Row>
                                        <Col xs={'auto'}>
                                            <ButtonGroup className="mt-3 w-100">
                                                <Button color="success" className="col" size="sm">Оплатит</Button>
                                                <Button color="warning" className="col" onClick={() => cancel()} size="sm">Отмена</Button>
                                            </ButtonGroup>
                                        </Col>
                                    </Row>
                                </form>

                            }

                        </div>
                            : <div className="text-center">
                                <div className="spinner-border me-3 ms-3 mt-1" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        }

                    </CardHeader>
                    <CardBody>
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col-1">#</th>
                                        <th scope="col">Продукт</th>
                                        <th scope="col">Серийный номер</th>
                                        <th scope="col">Цена</th>
                                        <th scope="col">Количество</th>
                                        <th scope="col">Сумма</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.items.map((item, index) =>
                                        <tr key={item.id}>
                                            <td>
                                                {index + 1}
                                            </td>
                                            <td>
                                                {item.product.name}
                                            </td>
                                            <td>
                                                {item.productSN}
                                            </td>
                                            <td>
                                                {item.price}
                                            </td>
                                            <td>{item.quantity}</td>
                                            <td>
                                                {(parseFloat(item.price) * item.quantity)} руб.
                                            </td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td colSpan={4}></td>
                                        <td>Сумма заказа:</td>
                                        <td><strong>{summ}</strong> руб.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
                : <LoadScreen />}
        </Container>
    )
}